type BoltIconProps = { className?: string; title?: string; transform?: string }

const BoltIcon = ({ className, title }: BoltIconProps) => (
  <svg width={21} height={24} className={className}>
    <title>{title}</title>
    <path
      d="M15.882 7.528A1 1 0 0015 7h-4.674l1.636-5.725A1 1 0 0011 0H4a1 1 0 00-.965.737l-3 11A1 1 0 001 13h4.802l-1.786 9.821a1 1 0 001.817.734l10-15c.204-.307.223-.701.05-1.027z"
      fill="#1A56DB"
      fillRule="nonzero"
    />
  </svg>
)

BoltIcon.defaultProps = {
  className: '',
  title: 'bolt icon'
}

export default BoltIcon
